import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Form } from "@angular/forms";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../service/auth-service/auth.service";
import { sweetAlert } from "../../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { LevelOfServiceService } from "../service/level-of-service.service";
import * as moment from 'moment';

@Component({
  selector: 'app-add-space-types',
  templateUrl: './add-space-types.component.html',
  styleUrls: ['./add-space-types.component.css']
})
export class AddSpaceTypesComponent implements OnInit {
  spaceTypeForm: UntypedFormGroup;
  submitted = false;
  userId = null;
  spaceTypeId;
  levelOfServices = [];
  status = "active";

  constructor(
    public authService: AuthService,
    private levelOfServiceService: LevelOfServiceService,
    private activatedRoute: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.params
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.spaceTypeId = params["id"];
        if (this.spaceTypeId) {
          this.getSpaceTypesbyId();
        }
      });

    this.spaceTypeForm = this.fb.group({
      title: ["", Validators.required],

      los: ["", Validators.required],
      status: ['active', Validators.required],
      description: [""],
      loadTime: ["",Validators.required],
      preLoadTime: [""],
      preUnLoadTime: [""],
      unloadTime: ["",Validators.required],
      wnr : [false]

    });

    this.getLevelOfService();
  }

  getSpaceTypesbyId() {
    this.levelOfServiceService.getServiceTypebyId(this.spaceTypeId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.spaceTypeForm.patchValue({
              ...data,
              preLoadTime: data.loadTime ? moment(data.loadTime,"HH:mm") : '',
              preUnLoadTime: data.unloadTime ? moment(data.unloadTime,"HH:mm") : "",
            })
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  saveSpaceType() {
    this.submitted = true;
    if (this.spaceTypeForm.invalid) {
      return;
    }
    let payload = this.spaceTypeForm.value;
    this.levelOfServiceService.saveServiceType(this.spaceTypeId, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigateByUrl("fleet/spaceTypes");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getLevelOfService() {
    const queryParams = {
      status: this.status
    }

    this.levelOfServiceService
      .getLevelOfServices(queryParams)
      .subscribe(data => {
        if (data && data.length) {
          this.levelOfServices = data;
        } else {
          this.levelOfServices = [];
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  onLoadTimeChange(evt) {
    this.spaceTypeForm.patchValue({
      loadTime: moment(evt).format("HH:mm"),
    });
  }

  onUnLoadTimeChange(evt) {
    this.spaceTypeForm.patchValue({
      unloadTime: moment(evt).format("HH:mm"),
    });
  }

  toggleWNR(wnr){
    this.spaceTypeForm.patchValue({
      wnr : !wnr
    })
  }

  get form() {
    return this.spaceTypeForm.controls;
  }

  ngOnDestroy(): void {
  }
}
